import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'

const module = 'visuals'
let doc = {
  list: {
    name: 'Visuels',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Client', value: 'client.name' },
      { label: 'Statut', value: 'status.name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['visuals.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['visuals.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Client', type: 'multilist', name: 'client_id', from: 'name', source: 'clients' },
    ],
  },

  form: {
    name: 'Visuel',
    hasPhoto: true,
    fields: [
      { label: 'Client', type: 'list', from: 'name', name: 'client_id', source: 'clients' },
      { label: 'Nom', type: 'text', name: 'name', hint: 'Nom du visuel' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['visuals.update'], dispatch: `${module}/update` },
      { label: 'Campagne', icon: 'exposure_plus_1', scope: ['campaigns.create'], dispatch: `${module}/createCampaign` },
      {
        label: 'Archiver',
        icon: 'delete',
        filter: {status_id: 7},
        scope: ['visuals.delete'],
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    relations: [
      {
        name: 'Campagnes',
        source: 'campaigns',
        headers: [
          { label: 'début', value: 'dateUp', orig: 'date_up', card: false },
          { label: 'fin', value: 'dateDown', orig: 'date_down', card: false },
          { label: 'Statut', value: 'status.name', card: false },
          { label: 'Dates', value: 'dates', sortable: false, inTable: false },
        ],
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `campaigns/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'client,status'},
    fetchOne: {include: 'client,status,campaigns.status'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    createCampaign: ({ commit, dispatch }, payload) => {
      console.log(payload)
      const { context, data } = payload
      dispatch('campaigns/goToList', {}, {root: true})
      commit('campaigns/UPDATE_FORM_FIELD', {key: 'visual.client_id', value: parseInt(data.client_id)}, {root: true})
      commit('campaigns/UPDATE_FORM_FIELD', {key: 'visual_id', value: parseInt(context.id)}, {root: true})
      commit('campaigns/OPEN_FORM', {client_id: context.id}, {root: true})
    },
  },
}
export default merge(base, custom)
